// extracted by mini-css-extract-plugin
module.exports =  {"Connection":"Connection-module__Connection___TMAyK"};